import Trash from './Trash';

export default Trash;
